import { QueryClient } from "@tanstack/react-query";

/**
 * Shared defaults: fewer accidental refetches, sane retries, smaller production payloads.
 * Session hydrate (`["me"]`) stays fresh longer to dedupe layout + route guards.
 */
function shouldRetryQuery(failureCount, error) {
  const status = error?.response?.status;
  if (status === 429 || status === 401 || status === 403) return false;
  return failureCount < 1;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: shouldRetryQuery,
    },
    mutations: {
      retry: 0,
    },
  },
});

queryClient.setQueryDefaults(["me"], {
  staleTime: 3 * 60_000,
  gcTime: 15 * 60_000,
});
